/**
 * Generic API Query Hook
 */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import type { ApiResponse, ApiError } from '../types';

export type QueryOptions<TData, TError = ApiError, TQueryKey extends readonly unknown[] = readonly unknown[]> = Omit<
  UseQueryOptions<ApiResponse<TData>, TError, ApiResponse<TData>, TQueryKey>,
  'queryFn'
> & {
  queryFn: () => Promise<ApiResponse<TData>>;
};

export function useApiQuery<TData = any, TError = ApiError, TQueryKey extends readonly unknown[] = readonly unknown[]>(
  options: QueryOptions<TData, TError, TQueryKey>
): UseQueryResult<ApiResponse<TData>, TError> {
  return useQuery<ApiResponse<TData>, TError, ApiResponse<TData>, TQueryKey>(options as any);
}

